import React from 'react';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

export default function MainTitle(props) {
  const useStyles = makeStyles({
    root: {
      marginLeft: '10%',
      fontSize: '16px',
      color: '#ffffff',
      maxWidth: '310px',
    },
  });

  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Typography variant="h1">{props.text}</Typography>
    </Box>
  );
}

MainTitle.propTypes = {
  text: PropTypes.string.isRequired,
};
